"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _fullBar, _smallBar;

  return {
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    brandLogo: {
      height: theme.spacing(6),
      marginRight: theme.spacing(2)
    },
    untouchedCaseButton: {
      textTransform: 'none'
    },
    flexGrow: {
      flexGrow: 1
    },
    appBarTitle: {
      paddingRight: theme.spacing(5)
    },
    loginLink: {
      color: 'inherit',
      "&:hover": {
        color: 'inherit'
      }
    },
    fullBar: (_fullBar = {}, _defineProperty(_fullBar, theme.breakpoints.down("sm"), {
      display: "none"
    }), _defineProperty(_fullBar, "flexGrow", 1), _defineProperty(_fullBar, "display", 'flex'), _fullBar),
    smallBar: (_smallBar = {}, _defineProperty(_smallBar, theme.breakpoints.up("md"), {
      display: "none"
    }), _defineProperty(_smallBar, "flexGrow", 1), _defineProperty(_smallBar, "display", 'flex'), _smallBar),
    avatar: {
      backgroundColor: '#FFFFFF',
      color: '#003061'
    },
    links: {
      color: 'inherit'
    },
    tabs: {
      backgroundColor: '#F5F5F5',
      color: 'rgba(0, 0, 0, 0.54)'
    }
  };
});
exports.useStyles = useStyles;